<template>
    <b-tabs content-class="apprentice-faq-index-content"
            class="apprentice-faq-index-tab apprentice-tab">
        <b-tab title="FAQ" active>
            <design-2021-admin-afaq-index-content-component
                :afaq-tags-in="afaqTags"
                :afaq-categories-in="afaqCategoriesIn">
            </design-2021-admin-afaq-index-content-component>
        </b-tab>

        <b-tab title="Tags">
            <design-2021-admin-afaq-index-tags-component
                :afaq-tags-in="afaqTags"
                @updateTags="updateTags($event)">
            </design-2021-admin-afaq-index-tags-component>
        </b-tab>
    </b-tabs>
</template>

<script>
export default {
    name: "design-2021-admin-afaq-index-component",
    props: ['afaqTagsIn','afaqCategoriesIn'],
    data() {
        return {
            afaqTags: this.afaqTagsIn,
            afaqCategories: this.afaqCategoriesIn,
            activeTab: 1,
            storageName: `faq-tab-index-${this.$authUser.id}`
        }
    },

    methods: {
        updateTags(tags) {
            this.afaqTags = tags;
        },
    }
}
</script>

<style scoped>

</style>
